export default __webpack_public_path__ + "static/media/icon-create-circle.3a43209b.svg";